import axios from "axios";
import { API_ROOT } from "../constants";
import { errorResponse } from "../helpers";

export const GET_MY_ORDERS_START = "GET_MY_ORDERS_START";
export const GET_MY_ORDERS_FAIL = "GET_MY_ORDERS_FAIL";
export const GET_MY_ORDERS_SUCCESS = "GET_MY_ORDERS_SUCCESS";

export function getMyOrders() {
	return function (dispatch, getState) {
		dispatch({
			type: GET_MY_ORDERS_START,
		});

		// Get the current token.
		const { session: { token } } = getState();

		axios.get(`${API_ROOT}/orders/mine`, {
			headers: {
				Authorization: `Bearer ${token}`
			},
		}).then(res => res.data).then(orders => {
			dispatch({
				type: GET_MY_ORDERS_SUCCESS,
				orders
			});
		}).catch(error => {
			dispatch({
				type: GET_MY_ORDERS_FAIL,
				error: errorResponse(error)
			});
		});
	}
}
